import { AutocompleteProps, useMantineTheme } from "@mantine/core";
import cx from "clsx";
import { Autocomplete as MantineAutocomplete } from "@mantine/core";
import { useState } from "react";
import classes from "./index.module.css";
import { getInputProps } from "@/components/inputProps";
import { Loader } from "@/components/Loader";

interface Props extends AutocompleteProps {
  isLoading?: boolean;
  /** Marks the rendered input as containing personal data so analytics tools exclude it (adds the `piiData` class). */
  pii?: boolean;
}

const Autocomplete = ({ isLoading, pii = false, ...autocompleteProps }: Props) => {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const [focused, setFocused] = useState(false);
  return (
    <MantineAutocomplete
      {...autocompleteProps}
      {...getInputProps(autocompleteProps, focused)}
      className={cx(autocompleteProps.className, { piiData: pii })}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      size="lg"
      classNames={classes}
      dropdownOpened={opened}
      onDropdownOpen={() => setOpened(true)}
      onDropdownClose={() => setOpened(false)}
      onClick={() => setOpened(true)}
      rightSection={isLoading && <Loader customColor={theme.colors.red[3]} />}
    />
  );
};

export default Autocomplete;
